class FormPath {
    private splitPath: string[];

    constructor(formPath: string) {
        this.splitPath = formPath.split(".");
    }

    public get sectionNumber(): number {
        return this.getValueAt(0);
    }

    public get elementNumber(): number {
        return this.getValueAt(1);
    }

    public get optionNumber(): number {
        return this.getValueAt(2);
    }

    public isSectionAndElementEqual(formPath: string): boolean {
        let obj = new FormPath(formPath);
        return this.sectionNumber === obj.sectionNumber
            && this.elementNumber === obj.elementNumber;
    }

    public toString(): string {
        if (this.sectionNumber === null)
            return "";

        let formPath = this.sectionNumber.toString();
        if (this.elementNumber !== null)
            formPath += "." + this.elementNumber;

        if (this.optionNumber !== null)
            formPath += "." + this.optionNumber;

        return formPath;
    }

    private getValueAt(index: number): number {
        if (this.splitPath.length <= index)
            return null;

        return Number(this.splitPath[index]);
    }
}

export { FormPath };
